module.exports = __webpack_public_path__ + "img/about_section_image.f0b5cc8c.png";